import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const Route = createFileRoute('/_private-routes/user-settings')({
  staticData: {
    menuTitle: MenuTitle.User
  }
});
